/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Event_Group_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Selected event group not found" |
*
* @param {Embed_Captions_Event_Group_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_event_group_not_found = /** @type {((inputs?: Embed_Captions_Event_Group_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Event_Group_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements selectionne introuvable")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisgruppe nicht gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi selezionato non trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбранная группа событий не найдена")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró el grupo de eventos seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到所选事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントグループが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de eventos selecionado não encontrado")
	return /** @type {LocalizedString} */ ("Selected event group not found")
});